import React, { useEffect, useState } from "react";
import "./TransactionPage.css";
import { FormControl, InputGroup, Row, Col, Container } from "react-bootstrap";
import NodatafoundPage from "../../nodatafound/components/NodatafoundPage";
import no_transaction from "./../../../assets/no_transaction.svg";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { FindPhone,  } from "../../comman/components/TimeSence";
import close_cross from "../../../assets/close_cross.svg";
import { MAGNIFY } from "../../comman/components/CommonimagePath";
import { useNavigate } from "react-router-dom";
import { getRequestcall } from "../../comman/util/getRequest";
import { TRANSACTION } from "../../constants/apiurl";
import PaginationPage from "../../comman/components/PaginationPage";
import ButtonPage from "../../comman/button/ButtonPage";
import SingleselectPage from "../../comman/customselect/SingleselectPage";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";


function TransactionPage(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { access_token } = props;
  const [orderList, setOrderList] = useState({});
  const [formData, setFormData] = useState({
    search:"",
    from_date:"",
    to_date:"",
    status:{label:"", value:""},
    subdays:{label:"", value:""}
  })

  const [noDatafound, setNoDatafound] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [clearField, setClearField] = useState(false);
  var [statuslist, setStatuslist] = useState(false);
  var [weeklist, setWeeklist] = useState(false);

  const subdays = [
    {
      label: t("pages.transactions.last_week"),
      title: "pages.transactions.last_week",
      value: 7,
    },
    {
      label: t("pages.transactions.last_two_week"),
      title: "pages.transactions.last_two_week",
      value: 14,
    },
    {
      label: t("pages.transactions.last_three_week"),
      title: "pages.transactions.last_three_week",
      value: 21,
    },
    {
      label: t("pages.transactions.last_four_week"),
      title: "pages.transactions.last_four_week",
      value: 28,
    },
    {
      label: t("pages.transactions.All"),
      title: "pages.transactions.All",
      value: "",
    },
  ];

  // const [dateSearch, setDateSearch] = useState("dd-mm-yyyy to dd-mm-yyyy");
  const statusOptions = [
    {
      label: t("pages.transactions.paid"),
      title: "pages.transactions.paid",
      value: t("pages.transactions.paid"),
    },
    {
      label: t("pages.transactions.unpaid"),
      title: "pages.transactions.unpaid",
      value: t("pages.transactions.unpaid"),
    },
  ];

  const onChangeInput = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e?.target?.value,
    });
  };

  useEffect(() => {
    callOrdertransactionlist(1, formData);
    // eslint-disable-next-line
  }, []);

  const onSelectStatus = (e, item, index) => {
    e.preventDefault();
    setFormData((data)=>({
      ...data,
      "status":item
    }))
  };

  const callOrdertransactionlist = async (page, formData, state) => {
    props?.fetchHeaderContent(t("pages.sidenav.transaction"), "", "");
    let Form = {...formData}
    if(Form?.from_date && Form?.to_date){
      Form.from_date = moment(Form?.from_date).format("YYYY-MM-DD")
    }else{
      Form.from_date = ""
    }
    if(Form?.from_date && Form?.to_date){
      Form.to_date = moment(Form?.to_date).format("YYYY-MM-DD")
    }else{
      Form.to_date = ""
    }
    let geturl = TRANSACTION + `?page=${page}&status=${Form?.status?.value}&subdays=${Form?.subdays?.value}&from_date=${Form?.from_date}&to_date=${Form?.to_date}`;
    let responce = await getRequestcall(geturl, access_token);
    if (responce?.status === 200) {
      let resultOrder = await responce.json();
      setOrderList(resultOrder?.data);
      if(state){
        setClearField(true);
      }else{
        setNoDatafound(false);
      }
    } else {
      if (responce?.status === 400) {
        setOrderList({ data: [] });
        if(!state){
          setNoDatafound(false);
        }
      } else if (responce?.status === 401) {
        navigate("/", { state: { autologout: true } });
      }
    }
  };

  const SelectsubDays = async (e, item, index) => {
    e.preventDefault();
    const Data = {
      ...formData,
      subdays:item
    }
    callOrdertransactionlist(1, Data, true);
    setFormData(Data);
    // console.log("item", item)
    // setsubDaySelect(item);

    // let geturl =
    //   TRANSACTION +
    //   `?page=${orderList?.current_page}&subdays=${item.value
    //   }&from_date=${""}&to_date=${""}`;
    // let responce = await getRequestcall(geturl, access_token);
    // if (responce?.status === 200) {
    //   let resultOrder = await responce.json();
    //   setOrderList(resultOrder?.data);
    // } else {
    //   if (responce?.status === 400) {
    //     setOrderList({ data: [] });
    //   }
    // }
  };

  // const changeInputDate = (e) => {
  //   setFilterDate({
  //     ...filterDate,
  //     [e.target.name]: e.target.value,
  //   });
  // };
  const addFilterValue = () => {
    if (formData?.from_date !== "" && formData?.to_date !== "") {
      // setDateSearch(`${formData?.from_date} to ${formData?.to_date}`);
      setShowModal(false);
    }
  };

  const validation = () => {
    let value = true;
    // if (subDaySelect?.value === "") {
    //   value = false;
    // }
    // if (formData?.from_date === "") {
    //   value = false;
    // }
    // if (formData?.to_date === "") {
    //   value = false;
    // }
    return value;
  };
  const searchTransation = async () => {
    if (validation()) {
      callOrdertransactionlist(1, formData, true);
    }
  };

  const callClearInput = () => {
    setFormData((sd)=>({
      ...sd,
      search:"",
      from_date:"",
      to_date:"",
      status:{label:"", value:""},
      subdays:{label:"", value:""}
    }));
    const formData = {
      search:"",
      from_date:"",
      to_date:"",
      status:{label:"", value:""},
      subdays:{label:"", value:""}
    }
    callOrdertransactionlist(1, formData);
    setClearField(false);
  };

  const callPaginationOrderList = async (e) => {
    callOrdertransactionlist(e, formData);
  };
  const closeDate = () => {
    if(formData?.from_date === "" && formData?.to_date === ""){
      setShowModal(false);
    }else if(formData?.from_date !== "" && formData?.to_date !== ""){
      setShowModal(true);
    }
  };
  const callClick = (e) =>{
    e.preventDefault()
    setShowModal(true)
  }

  if (noDatafound)
    return (
      <NodatafoundPage
        className={"col-xl-9 main-content transaction-centent"}
        image={no_transaction}
        button={t("pages.backtodashboard")}
        title={t("pages.transactions.no_transaction")}
        description={t("pages.transactions.notran_subtitle")}
        navigation={"/vendor/dashboard"}
      />
    );


  return (
    <div className="col-xl-9 main-content transaction-centent">
      <div className="block-inline">
        <div className="left-side">
          <h5 className="header-title">{t("pages.transactions.title")}</h5>
        </div>
      </div>
      <div className={"d-flex flex-row row filter_div"}>
        <div className="col-lg-3 col-xl-4 col-sm-2 col-md-2 col-md-2 col-6 ">
          <InputGroup className={" w-100 mb-3 "}>
            <FormControl
              id={"search"}
              className={"max-width"}
              name={"search"}
              onChange={onChangeInput}
              value={formData?.search}
              placeholder={t("pages.transactions.search_place")}
            />
          </InputGroup>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-2 col-6 mb-3 position-relative">
          <SingleselectPage
            groupItemClick={onSelectStatus}
            list={statusOptions}
            setShowList={setStatuslist}
            showList={statuslist}
            placeholder={t("pages.transactions.status")}
            value={formData?.status?.title?t(formData?.status?.title):""}
            inputClassName={"status-paid"}
          />
        </div>
        <div className={"col-xl-2 col-lg-3 col-md-2 col-6 mb-3"}>
          <SingleselectPage
            groupItemClick={SelectsubDays}
            list={subdays}
            setShowList={setWeeklist}
            showList={weeklist}
            placeholder={t("pages.transactions.status")}
            value={formData?.subdays?.value?t(formData?.subdays?.title):""}
            inputClassName={"status-week"}
          />
        </div>
        <InputGroup className={"w-auto mb-3"} onClick={callClick}>
          <FormControl
            id={"search"}
            className={"date_filter"}
            placeholder={t("pages.transactions.paymentid")}
            value={`${formData?.to_date && formData?.from_date ? `${moment(formData?.from_date).format("DD-MM-YYYY")} ${t('pages.to')} ${moment(formData?.to_date).format("DD-MM-YYYY")}` : `${t("pages.dd-mm-yyyy")} ${t('pages.to')} ${t("pages.dd-mm-yyyy")}` } `}
          />
        </InputGroup>
        {clearField && (
          <div className={"w-auto"}>
            <span className={"search_pr_btn close"} onClick={() => callClearInput()}>
              <img src={close_cross} alt="close"></img>
            </span>
          </div>
        )}
        <div className={"w-auto"}>
          <span className={"search_pr_btn"} onClick={() => searchTransation()}>
            <img src={MAGNIFY} alt="search" height="25" width="25"></img>
          </span>
        </div>
      </div>
      <Row className="mt-2 mb-3 sold desktops">
        <Container>
          <Row className="response-list-header ">
            <Col sm={12} md={12} lg={1} xl={1} className="ms-1">
              <h5 className="row-header">
                {t("pages.transactions.paymentid")}
              </h5>
            </Col>
            <Col sm={12} md={12} lg={1} xl={1}>
              <h5 className="row-header">{t("pages.transactions.orderid")}</h5>
            </Col>
            <Col sm={12} md={12} lg={1} xl={1}>
              <h5 className="row-header">{t("pages.transactions.amount")}</h5>
            </Col>
            <Col sm={12} md={12} lg={2} xl={2}>
              <h5 className="row-header">{t("pages.transactions.datetime")}</h5>
            </Col>
            <Col sm={12} md={12} lg={1} xl={1}>
              <h5 className="row-header">{t("pages.transactions.name")}</h5>
            </Col>
            <Col sm={12} md={12} lg={2} xl={2}>
              <h5 className="row-header">{t("pages.transactions.email")}</h5>
            </Col>
            <Col sm={12} md={12} lg={2} xl={2}>
              <h5 className="row-header">{t("pages.transactions.contact")}</h5>
            </Col>
            <Col sm={12} md={12} lg={1} xl={1} className="text-center">
              <h5 className="row-header">{t("pages.transactions.status")}</h5>
            </Col>
          </Row>
          {orderList?.data
            ?.filter((label) => {
              const data =
                label?.payment_id
                  ?.toLowerCase()
                  ?.includes(formData?.search?.toLowerCase()) ||
                label?.email
                  ?.toLowerCase()
                  ?.includes(formData?.search?.toLowerCase()) ||
                label?.name
                  ?.toLowerCase()
                  ?.includes(formData?.search?.toLowerCase()) ||
                label?.mobile
                  ?.toLowerCase()
                  ?.includes(formData?.search?.toLowerCase()) ||
                label?.payment_status
                  ?.toLowerCase()
                  ?.includes(formData?.search?.toLowerCase()) ||
                label?.order_id
                  ?.toLowerCase()
                  ?.includes(formData?.search?.toLowerCase());
              return data;
            })
            ?.map((item, index) => (
              <div className="response-list" key={index?.toString()}>
                <Row className="align-items-center">
                  <Col sm={12} md={12} lg={1} xl={1} className="ms-1">
                    <div className="item-box">
                      <h5 className="mobile-header">
                        {t("pages.transactions.paymentid")}
                      </h5>
                      <h5>{item.payment_id}</h5>
                    </div>
                  </Col>
                  <Col sm={12} md={12} lg={1} xl={1}>
                    <div className="item-box">
                      <h5 className="mobile-header">
                        {t("pages.transactions.orderid")}
                      </h5>
                      <h5>{item.display_order_id}</h5>
                    </div>
                  </Col>
                  <Col sm={12} md={12} lg={1} xl={1}>
                    <div className="item-box">
                      <h5 className="mobile-header">
                        {t("pages.transactions.amount")}
                      </h5>
                      <h5>
                        {item.order_total}
                        {process.env.REACT_APP_CURRENCY_SYMBOL}
                      </h5>
                    </div>
                  </Col>
                  <Col sm={12} md={12} lg={2} xl={2}>
                    <div className="item-box">
                      <h5 className="mobile-header">
                        {t("pages.transactions.datetime")}
                      </h5>
                      <h5 style={{ whiteSpace: "normal" }}>{moment(item.datetime).format("DD-MMM-YYYY hh:mm A")}</h5>
                    </div>
                  </Col>
                  <Col sm={12} md={12} lg={1} xl={1}>
                    <div className="item-box">
                      <h5 className="mobile-header">
                        {t("pages.transactions.name")}
                      </h5>
                      <h5 style={{ whiteSpace: "normal" }}>{item.name}</h5>
                    </div>
                  </Col>
                  <Col sm={12} md={12} lg={2} xl={2}>
                    <div className="item-box">
                      <h5 className="mobile-header">
                        {t("pages.transactions.email")}
                      </h5>
                      <h5 style={{ whiteSpace: "normal" }}> {item.email}</h5>
                    </div>
                  </Col>
                  <Col sm={12} md={12} lg={2} xl={2}>
                    <div className="item-box">
                      <h5 className="mobile-header">
                        {t("pages.transactions.contact")}
                      </h5>
                      <h5>
                        <FindPhone country_code={item?.country_code} mobile={item?.mobile} />
                      </h5>
                    </div>
                  </Col>
                  <Col sm={12} md={12} lg={1} xl={1} className="text-center">
                    <div className="item-box border-bottom-0">
                      <h5 className="mobile-header">
                        {t("pages.transactions.status")}
                      </h5>
                      <h5 className={`statuss ${item.payment_status}`}>
                        {item.payment_status === "Unpaid"
                          ? t("pages.transactions.unpaid")
                          : t("pages.transactions.paid")}
                      </h5>
                    </div>
                  </Col>
                </Row>
              </div>
            ))}
        </Container>
      </Row>
      <Modal show={showModal} className="datepopup">
        <Modal.Body>
          <img
            src={close_cross}
            alt="close"
            height="25"
            width="25"
            onClick={() => closeDate()}
            className="close-icon"
            style={{ top: "-10px", right: "-10px", background: "white" }}
          />
          <Row>
            <div className="col-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-3">
              <label htmlFor="from_date" className="form-label">
                {t("pages.transactions.From date")}
              </label>
              {/* <FormControl
                name={"from_date"}
                type={"date"}
                id={"from_date"}
                onChange={changeInputDate}
                value={formData?.from_date}
              /> */}
              <DatePicker locale={props?.language.toLowerCase()} className="form-control" showIcon selected={formData?.from_date ? formData?.from_date : null} dateFormat={"dd-MM-yyyy"} onChange={(date) => setFormData((data)=>({...data,from_date:date}))}  placeholderText={t('pages.dd-mm-yyyy')}/>

            </div>
            <div className="col-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-3">
              <label htmlFor="to_date" className="form-label">
                {t("pages.transactions.To date")}
              </label>
              {/* <FormControl
                name={"to_date"}
                id={"to_date"}
                onChange={changeInputDate}
                value={formData?.to_date}
                type={"date"}
              /> */}
              <DatePicker locale={props?.language.toLowerCase()} className="form-control" showIcon selected={formData?.to_date ? formData?.to_date : null} dateFormat={"dd-MM-yyyy"} onChange={(date) => setFormData((data)=>({...data,to_date:date}))}  placeholderText={t('pages.dd-mm-yyyy')}/>
            </div>
            <div className="text-end">
              <ButtonPage
                Text={t("pages.transactions.Search")}
                onClick={() => addFilterValue()}
                className="button-submit "
                type="button"
              />
            </div>
          </Row>
        </Modal.Body>
      </Modal>
      {!noDatafound && orderList?.total > 10 && (
        <div className="text-end">
          <PaginationPage
            changeCurrentpage={callPaginationOrderList}
            nopagination={noDatafound}
            links={orderList?.links}
          />
        </div>
      )}
    </div>
  );
}
const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { fetchHeaderContent })(
  TransactionPage
);
